import { PackagesEnum } from "../../enums/packages.enum";
import { AppConfigModel } from "../abstract/app-config.model";
import { PackageContent } from "./package-content.model";

export class Package extends AppConfigModel {

    static override CLASS_NAME: string = 'Package';

    readonly description!: string;

    private _annualPriceXpf!: number;
    private _features!: PackageContent[];
    private _level!: number;
    private _monthlyPriceXpf!: number;

    public getFeature(featureCode: string): PackageContent | null {
        return this._features.find((f) => f.feature.code === featureCode) ||
            null;
    }

    public hasFeature(featureCode: string): boolean {
        return this._features.some((f) => f.feature.code === featureCode);
    }

    public get annualPriceXpf(): number {
        return this._annualPriceXpf;
    }

    public set annualPriceXpf(value: any) {
        this._annualPriceXpf = parseFloat(value);
    }

    public get features(): PackageContent[] {
        return this._features;
    }

    public set features(value: any) {
        this._features = [];
        for (let i = 0; i < value.length; i++) {
            this._features.push(new PackageContent(value[i]));
        }
    }

    public get level(): number {
        return this._level;
    }

    public set level(value: any) {
        this._level = parseInt(value);
    }

    public get monthlyPriceXpf(): number {
        return this._monthlyPriceXpf;
    }

    public set monthlyPriceXpf(value: any) {
        this._monthlyPriceXpf = parseFloat(value);
    }

    public get severity(): 'primary' | 'secondary' | 'success' | 'danger' | 'warn' | 'help' | undefined {
        switch (true) {
            case this.code === PackagesEnum.Trial:
                return 'secondary';
            case this.code === PackagesEnum.Free:
                return 'danger';
            case this.code === PackagesEnum.Business:
                return 'warn';
            case this.code === PackagesEnum.BusinessPlus:
                return 'primary';
            case this.code === PackagesEnum.Premium:
                return 'success';
            case this.code === PackagesEnum.Ocr:
                return 'help';
        }
        return undefined;
    }
}
